import { JSM_TASK_LIST, JSM_TASK_VARIANTS, UserRole, Experiments } from './constants.tsx';

export const JSM = {
	taskList: JSM_TASK_LIST,
	taskVariants: JSM_TASK_VARIANTS,
	userRole: UserRole,
	experiments: Experiments,
} as const;
